"use strict";

/**
 * Holds breakpoint values which can be required in multiple js files
 * @type {Object}
 */
const globalBreakpoints = Object.freeze({
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
});

module.exports = {
    globalBreakpoints: globalBreakpoints,
};
